// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Tooltip-cls1___239325969fe6515b9bf{/*!*/}.Tooltip-cls2___77be066943fea23c4da{display:flex;flex-direction:column;align-items:center;align-self:stretch;background:transparent;grid-gap:0;gap:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Tooltip-cls1___239325969fe6515b9bf",
	"cls2": "Tooltip-cls2___77be066943fea23c4da Tooltip-cls1___239325969fe6515b9bf"
};
export default ___CSS_LOADER_EXPORT___;
